import React, {useContext, useEffect, useState, useRef, SyntheticEvent } from 'react';
import AppLayout from 'components/AppLayout/AppLayout';
import AppDrawer from 'components/AppDrawer/AppDrawer';
import Typography from '@mui/material/Typography';
import GppMaybe from '@mui/icons-material/GppMaybe';

import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Item from '@mui/material/Grid';

import "i18n/config";
import { useTranslation } from 'react-i18next';

import { toast } from 'react-toastify'
import { DataContext } from 'contexts/DataContext';
import { get, update} from './api';
import { Accordion, AccordionDetails, AccordionSummary, TextField } from '@mui/material';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import { InfoRounded } from '@mui/icons-material';
import theme from "theme";

const Impact = () => {
    const [impact, setImpact] = useState({} as any);
    const [saving, setSaving] = useState(false);
    const dataContext = useContext(DataContext);
    const formRef = useRef<HTMLFormElement>(null);
    const { t } = useTranslation();

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        dataContext.changeShowLoader(true);
        const data = new FormData(event.currentTarget);
        console.log(data.get('confidentiality'));
        update(dataContext.currentAssessment, data).then((response) => {
            setImpact(response);
            toast.success('Impact saved', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                });
            
            setSaving(false);
            dataContext.changeShowLoader(false);
        });
    };

    useEffect(() => {
        if(dataContext.loading) return;
        if(!dataContext.currentAssessment) return;
        get(dataContext.currentAssessment).then((response) => {
            setImpact(response);
        });
    }, [dataContext.loading, dataContext.currentAssessment]);


    return (
        <AppLayout drawerOpen={true} drawer={<AppDrawer />} 
        title={<><Typography variant='pageTitle'>Impact</Typography></>} 
        actions={dataContext.user?.id_role===1 ? [] :[
            {
                label: saving ? t('Saving...') : t('Save'),
                disabled: saving ? true : false,
                action: (event: SyntheticEvent) => {
                    setSaving(true);
                    formRef.current?.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                }
            }
        ]}>
        <Box ref={formRef} component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 0 }}>
        
        <Paper sx={{marginTop:1, padding:1}}>
            <Box sx={{margin:1}}>
                <Grid container spacing={2} alignItems='start'>
                    <Grid item xs={10}>
                        <Item>
                            <Typography variant='paperTitle'>Riservatezza</Typography>
                            <Typography sx={{fontSize:14}}>
                            Valutare l'impatto che una divulgazione non autorizzata (perdita di riservatezza) dei dati trattati nel contesto in cui si svolgono le attività potrebbe avere sulle persone, sui servizi o sull'intera Organizzazione, esprimendo una valutazione qualitativa. Come riferimento, considerare gli scenari di impatto riporati come esempio ed esprimere un giudizio qualitativo utilizzando una scala ordinale a cinque valori (Alto, Medio Alto, Medio, Medio Basso, Basso).
                            </Typography>
                            <TextField
                                name={'confidentiality_notes'}
                                multiline
                                maxRows={4}
                                InputProps={{ sx: { borderRadius: 0 } }}
                                variant="filled"
                                fullWidth
                                hiddenLabel
                                defaultValue={impact.confidentiality_notes}
                                key={impact.confidentiality_notes}
                                sx={{marginTop:1}}
                            />
                            <Accordion sx={{fontSize:14}}>
                                <AccordionSummary
                                expandIcon={<GridExpandMoreIcon />}
                                aria-controls="coverage-accordion"
                                id="coverage-accordion"
                                >
                                <Box sx={{display:'flex', alignItems:'center'}}>
                                <InfoRounded sx={{marginRight:1}} /> Esempi/Scenari di perdita della riservatezza		
                                </Box>
                                </AccordionSummary>
                                <AccordionDetails sx={{backgroundColor:'background.paper'}}>

                                Ripercussioni negative sull'immagine dell'Organizzazione in termini di opinione (giudizio negativo) del pubblico, di stakeholder e/o di fornitori, derivanti da violazioni della riservatezza delle informazioni trattate. Ad esempio: data breach con diffusione su internet di dati di proprietà dell'Organizzazione.		
                                <br/>Perdite operative dovute a sanzioni o risarcimenti a Clienti/Fornitori conseguenti alla perdita di confidenzialità delle informazioni.		
                                <br/>Vantaggi competitivi per la concorrenza derivanti dalla perdita della riservatezza delle informazioni (ad es. dati di brevetti, dati su campagne di marketing, ecc.).		
                                <br/>Violazioni involontarie alla riservatezza dovute a comportamenti non corretti da parte di utenti o fornitori (data leak). Ad esempio:
                                <ul>
                                    <li>perdita/furto di dispositivi rimovibili lasciati incustoditi;</li>
                                    <li>dismissione non sicura di dispositivi di archiviazione;</li>
                                    <li>configurazioni errate sui sistemi IT che consentono l'accesso non autorizzato ai dati;</li>    
                                </ul>
                         
                                </AccordionDetails>
                            </Accordion>
	
                        </Item>
                    </Grid>

                    <Grid item xs={2}>
                        <Item>
                            <FormControl fullWidth>
                                <InputLabel id="confidentiality-select-label">{t("Confidentiality")}</InputLabel>
                                <Select
                                    labelId="confidentiality-select-label"
                                    label={t("Confidentiality")}
                                    name='confidentiality'
                                    defaultValue={impact.confidentiality && impact.confidentiality!==0 ? impact.confidentiality : ''}
                                    key={impact.confidentiality}
                                    disabled={dataContext.user?.id_role===1}
                                    >
                                    <MenuItem value='1'>{t('Low')}</MenuItem>
                                    <MenuItem value='2'>{t('MediumLow')}</MenuItem>
                                    <MenuItem value='3'>{t('Medium')}</MenuItem>
                                    <MenuItem value='4'>{t('MediumHigh')}</MenuItem>
                                    <MenuItem value='5'>{t('High')}</MenuItem>
                                </Select>
                            </FormControl>
                        </Item>
                    </Grid>
                </Grid>
            </Box>
        </Paper>

        <Paper sx={{marginTop:1, padding:1}}>
            <Box sx={{margin:1}}>
                <Grid container spacing={2} alignItems='start'>
                    <Grid item xs={10}>
                        <Item>
                            <Typography variant='paperTitle'>Integrità</Typography>
                            <Typography sx={{fontSize:14}}>
                            Valutare l'impatto che una alterazione non autorizzata (perdita di integrità) dei dati trattati nel contesto in cui si svolgono le attività potrebbe avere sulle persone, sui servizi o sull'intera Organizzazione, esprimendo una valutazione qualitativa. Come riferimento, considerare gli scenari di impatto riporati come esempio  ed esprimere un giudizio qualitativo utilizzando una scala ordinale a cinque valori (Alto, Medio Alto, Medio, Medio Basso, Basso).
                            </Typography>
                            <TextField
                                name={'integrity_notes'}
                                multiline
                                maxRows={4}
                                InputProps={{ sx: { borderRadius: 0 } }}
                                variant="filled"
                                fullWidth
                                hiddenLabel
                                defaultValue={impact.integrity_notes}
                                key={impact.integrity_notes}
                                sx={{marginTop:1}}
                            />
                            <Accordion sx={{fontSize:14}}>
                                <AccordionSummary
                                expandIcon={<GridExpandMoreIcon />}
                                aria-controls="coverage-accordion"
                                id="coverage-accordion"
                                >
                                <Box sx={{display:'flex', alignItems:'center'}}>
                                <InfoRounded sx={{marginRight:1}} /> Esempi/Scenari di perdita della integrità		
                                </Box>
                                </AccordionSummary>
                                <AccordionDetails sx={{backgroundColor:'background.paper'}}>
                                Ripercussioni negative sull'immagine dell'Organizzazione in termini di opinione (giudizio negativo) del pubblico, di stakeholder e/o di fornitori, derivanti da violazioni della integrità delle informazioni trattate. 
                                <br />Ad esempio: 
                                <ul>
                                    <li>errori sistematici nelle elaborazioni con produzione di dati errati.</li>
                                </ul>	
                                Perdite operative dovute a sanzioni o risarcimenti a Clienti/Fornitori conseguenti alla perdita di integrità/alterazione delle informazioni trattate.		
                                <br />Perdite dirette in termini di costi aggiuntivi o efficienza operativa derivanti  dalla perdita di integrità dei dati. 
                                <br />Ad esempio:
                                <ul>
                                    <li>inefficienze/rallentamenti dovuti all'attuazione di procedure di emergenza, workaround o procedure manuali;</li>
                                    <li>costi/inefficienze derivati dall'attivazione di procedure di recovery dei dati;</li>
                                    <li>cosi per la risoluzione dei guasti.</li>
                                </ul>
                                </AccordionDetails>
                            </Accordion>
                        </Item>
                    </Grid>

                    <Grid item xs={2}>
                        <Item>
                        <FormControl fullWidth>
                            <InputLabel id="integrity-select-label">{t("Integrity")}</InputLabel>
                            <Select
                                labelId="integrity-select-label"
                                label={t("Integrity")}
                                name='integrity'
                                defaultValue={impact.integrity && impact.integrity!==0 ? impact.integrity : ''}
                                key={impact.integrity}
                                disabled={dataContext.user?.id_role===1}
                                >
                                <MenuItem value='1'>{t('Low')}</MenuItem>
                                <MenuItem value='2'>{t('MediumLow')}</MenuItem>
                                <MenuItem value='3'>{t('Medium')}</MenuItem>
                                <MenuItem value='4'>{t('MediumHigh')}</MenuItem>
                                <MenuItem value='5'>{t('High')}</MenuItem>
                            </Select>
                        </FormControl>

                        </Item>
                    </Grid>
                </Grid>
            </Box>
        </Paper>

        <Paper sx={{marginTop:1, padding:1}}>
            <Box sx={{margin:1}}>
                <Grid container spacing={2} alignItems='start'>
                    <Grid item xs={10}>
                        <Item>
                            <Typography variant='paperTitle'>Disponibilità</Typography>
                            <Typography sx={{fontSize:14}}>
                            Valutare l'impatto che una distruzione o perdita di disponibilità dei dati trattati nel contesto in cui si svolgono le attività potrebbe avere sulle persone, sui servizi o sull'intera Organizzazione, esprimendo una valutazione qualitativa. Come riferimento, considerare gli scenari di impatto riporati come esempio  ed esprimere un giudizio qualitativo utilizzando una scala ordinale a cinque valori (Alto, Medio Alto, Medio, Medio Basso, Basso).	
                            </Typography>
                            <TextField
                                name={'availability_notes'}
                                multiline
                                maxRows={4}
                                InputProps={{ sx: { borderRadius: 0 } }}
                                variant="filled"
                                fullWidth
                                hiddenLabel
                                defaultValue={impact.availability_notes}
                                key={impact.availability_notes}
                                sx={{marginTop:1}}
                            />
                            <Accordion sx={{fontSize:14}}>
                                <AccordionSummary
                                expandIcon={<GridExpandMoreIcon />}
                                aria-controls="coverage-accordion"
                                id="coverage-accordion"
                                >
                                <Box sx={{display:'flex', alignItems:'center'}}>
                                <InfoRounded sx={{marginRight:1}} /> Esempi/Scenari di perdita della disponibilità		
                                </Box>
                                </AccordionSummary>
                                <AccordionDetails sx={{backgroundColor:'background.paper'}}>
                                Ripercussioni negative sull'immagine dell'Organizzazione in termini di opinione (giudizio negativo) del pubblico, di stakeholder e/o di fornitori, derivanti dall'impossibilità di erogare servizi criti, come conseguenza della mancata disponibilità delle informazioni trattate. 
                                <br />Ad esempio: 
                                <ul>
                                    <li>blocco di siti pubblici/portali per effetto di attacchi di defacement;</li>
                                    <li>blocco di servizi per effetto di attacchi di defacement;</li>
                                </ul>	
                                Perdite operative dovute a sanzioni o risarcimenti a Clienti/Fornitori conseguenti alla perdita delle informazioni trattate.		
                                <br />Perdite dirette in termini di costi aggiuntivi o efficienza operativa derivanti  dalla perdita di disponibilità dei dati. 
                                <br />Ad esempio:
                                <ul>
                                    <li>inefficienze/rallentamenti dovuti all'attuazione di procedure di emergenza, workaround o procedure manuali;</li>
                                    <li>costi/inefficienze derivati dall'attivazione di procedure di recovery dei dati o di ricostruzione di basi dati eventualmente danneggiate;</li>
                                    <li>cosi per la risoluzione dei guasti.</li>
                                </ul>
                                </AccordionDetails>
                            </Accordion>
                        </Item>
                    </Grid>

                    <Grid item xs={2}>
                        <Item>
                        <FormControl fullWidth>
                            <InputLabel id="availability-select-label">{t("Availability")}</InputLabel>
                            <Select
                                labelId="availability-select-label"
                                label={t("Availability")}
                                name='availability'
                                defaultValue={impact.availability && impact.availability!==0 ? impact.availability : ''}
                                key={impact.availability}
                                disabled={dataContext.user?.id_role===1}
                                >
                                <MenuItem value='1'>{t('Low')}</MenuItem>
                                <MenuItem value='2'>{t('MediumLow')}</MenuItem>
                                <MenuItem value='3'>{t('Medium')}</MenuItem>
                                <MenuItem value='4'>{t('MediumHigh')}</MenuItem>
                                <MenuItem value='5'>{t('High')}</MenuItem>
                            </Select>
                        </FormControl>
                        </Item>
                    </Grid>
                </Grid>
            </Box>
        </Paper>

        </Box>
      </AppLayout>
    )
}

export default Impact;